

import { useState, useCallback } from 'react';
import MetadataService from '../services/metadataService';
import { useAutomationContext } from '../context/AutomationContext';
import { useAuth } from 'auth/Auth';

export function useReferenceData() {
  const { state, actions } = useAutomationContext();
  const [loading, setLoading] = useState({});
  const { axiosInstance } = useAuth();
  const metadataService = new MetadataService({ axiosInstance });

  const fetchReferenceData = useCallback(async (endpoint, params = {}) => {
    const cacheKey = `${endpoint}_${JSON.stringify(params)}`;
    
    // Check cache first
    if (state.referenceDataCache[cacheKey]) {
      return state.referenceDataCache[cacheKey];
    }

    // Check if already loading
    if (loading[cacheKey]) {
      return null;
    }

    setLoading(prev => ({ ...prev, [cacheKey]: true }));
    
    try {
      const data = await metadataService.getReferenceData(endpoint, params);
      actions.setReferenceData(cacheKey, data);
      return data;
    } catch (error) {
      console.error(`Error fetching reference data from ${endpoint}:`, error);
      return [];
    } finally {
      setLoading(prev => {
        const newLoading = { ...prev };
        delete newLoading[cacheKey];
        return newLoading;
      });
    }
  }, [state.referenceDataCache, loading, actions]);

  const clearCache = useCallback((endpoint = null) => {
    if (endpoint) {
      // Clear specific endpoint cache
      const keysToRemove = Object.keys(state.referenceDataCache)
        .filter(key => key.startsWith(endpoint));
      // Would need to implement a clear specific cache action
    } else {
      // Clear all cache - would need to implement
    }
  }, [state.referenceDataCache]);

  return {
    fetchReferenceData,
    clearCache,
    loading,
    cache: state.referenceDataCache
  };
}
